export const MONITORING_ACTION_TYPE = {
  EMAIL: 'EMAIL',
};
